import React from 'react';
import './checkbox.scss';

interface IProps {
  checked: boolean;
  onChange: (e: boolean) => void;
  labelText: any;
  showAlert?: boolean;
  alertMsg?: string;
  labelClassName?: string;
}

const CheckBox = ({
  checked,
  onChange,
  labelText,
  showAlert,
  alertMsg,
  labelClassName
}: IProps) => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };
  const id = `checkbox-${s4()}`;
  let textDoesContainHTMLTags = false;

  if (/<\/?[a-z][\s\S]*>/i.test(labelText)) { 
    textDoesContainHTMLTags = true;
  }
  
  return (
    <div className="ys-checkbox">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        id={id}
        className={`ys-checkbox__control ys-u-visuallyhidden ${!!showAlert && 'checkbox--alert'}`}
      />
      {textDoesContainHTMLTags ?
      <label dangerouslySetInnerHTML={{__html: labelText}} htmlFor={id} className={`ys-checkbox__label ${labelClassName}`}>
      </label> :
      <label htmlFor={id} className={`ys-checkbox__label ${labelClassName}`}>{labelText}</label>
    }
      {showAlert && <p className="checkbox__alert">{alertMsg}</p>}
    </div>
  );
};

export default CheckBox;
